import axios from 'axios';
import dayjs from 'dayjs';

const baseUrl = `${import.meta.env.VITE_API_BASE_URL}`;

export const fetchPackageTypes = async () => {
  const res = await axios.get(`${baseUrl}/packages`);
  return res.data;
};

export const fetchClientName = async (clientId) => {
  try {
    const res = await axios.get(`${baseUrl}/clients/${clientId}`);
    const name = res.data.Name;
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  } catch (error) {
    console.error('Error fetching client:', error);
    return 'Unknown';
  }
};

export const fetchQuotations = async () => {
  const res = await axios.get(`${baseUrl}/quotations`);
  return res.data.map(q => ({
    ...q,
    createdAt: dayjs(q.CreatedAt).format('DD MMM YYYY'),
    amount: q.TotalAmount ? `$${parseFloat(q.TotalAmount).toFixed(2)}` : '-'
  }));
};

export const deleteQuotation = async (quotationId) => {
  return axios.delete(`${baseUrl}/quotations/${quotationId}`);
};

export const downloadPDF = async (quotationId, isPrint = false) => {
  return axios.get(`${baseUrl}/pdf/${quotationId}?print=${isPrint}`, {
    responseType: 'blob'
  });
};

export const copyQuotation = async (quotationId) => {
  return axios.post(`${baseUrl}/quotations/${quotationId}/copy`);
};